import { Navbar } from "../../components/navbar"
import Statelogin from "./component/Statelogin"

const latihan = () => {
  return (
    <div>
      <Navbar />
        <h1>Ini adalah Halaman Login</h1>
        <Statelogin/>
        
        </div>
  )
}

export default latihan